import { render } from "./sticky-feedback.vue?vue&type=template&id=0724951d"
import script from "./sticky-feedback.vue?vue&type=script&lang=js"
export * from "./sticky-feedback.vue?vue&type=script&lang=js"

import "./sticky-feedback.vue?vue&type=style&index=0&id=0724951d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__